export default "__VITE_ASSET__D$e7WtCT__"